'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineTextArea = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

var _baseAccessibilityTextArea = require('@bibliocommons/base-accessibility-text-area');

var _baseAccessibilityTextArea2 = _interopRequireDefault(_baseAccessibilityTextArea);

require('../styles/InlineTextArea.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InlineTextArea = exports.InlineTextArea = function (_BcReactComponent) {
  _inherits(InlineTextArea, _BcReactComponent);

  function InlineTextArea(props) {
    _classCallCheck(this, InlineTextArea);

    var _this = _possibleConstructorReturn(this, (InlineTextArea.__proto__ || Object.getPrototypeOf(InlineTextArea)).call(this, props));

    _this.state = {
      editMode: false
    };
    _this.bindAll('handleBlur', 'handleClick', 'handleButtonFocus', 'renderValue');
    return _this;
  }

  _createClass(InlineTextArea, [{
    key: 'handleBlur',
    value: function handleBlur() {
      this.setState({ editMode: false });
    }
  }, {
    key: 'handleButtonFocus',
    value: function handleButtonFocus() {
      if (this.props.openOnFocus) {
        this.setState({ editMode: true });
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.setState({ editMode: true });
    }
  }, {
    key: 'renderValue',
    value: function renderValue() {
      if (this.props.value) {
        return _react2.default.createElement(
          'div',
          { className: 'text-area-value' },
          this.props.children,
          _react2.default.createElement(
            _baseButtons.TextButton,
            {
              className: 'edit-button',
              handleClick: this.handleClick,
              onFocus: this.handleButtonFocus,
              'data-test-id': this.props.buttonTestId,
              'aria-label': this.props.intl.formatMessage({ id: 'button_edit' }) },
            _react2.default.createElement(_baseIcons.Pencil, null),
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_edit' })
          )
        );
      }
      return _react2.default.createElement(
        _baseButtons.TextButton,
        {
          handleClick: this.handleClick,
          onFocus: this.handleButtonFocus,
          className: 'prompt',
          'aria-label': this.props.intl.formatMessage({ id: 'button_edit' }),
          'data-test-id': this.props.buttonTestId },
        _react2.default.createElement(_baseIcons.Pencil, null),
        _react2.default.createElement(
          'span',
          null,
          this.props.prompt
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var extraClasses = this.props.highlightOnHover ? 'highlight-on-hover' : '';
      return _react2.default.createElement(
        'div',
        { className: 'cp-inline-text-area ' + extraClasses },
        this.state.editMode ? _react2.default.createElement(_baseAccessibilityTextArea2.default, {
          setFocus: true,
          id: this.props.id,
          value: this.props.value,
          suggestedMaxLength: this.props.suggestedMaxLength,
          maxLength: this.props.maxLength,
          handleBlur: this.handleBlur,
          className: this.props.customClass,
          handleChange: this.props.handleChange,
          errorKey: 'InlineTextArea',
          labelledById: this.props.labelledById,
          describedById: this.props.describedById,
          testId: this.props.inputTestId,
          fitToText: this.props.fitToText }) : this.renderValue()
      );
    }
  }]);

  return InlineTextArea;
}(_baseBcReactComponent2.default);

InlineTextArea.propTypes = {
  id: _react.PropTypes.string,
  value: _react.PropTypes.string,
  handleChange: _react.PropTypes.func,
  prompt: _react.PropTypes.string,
  maxLength: _react.PropTypes.number,
  suggestedMaxLength: _react.PropTypes.number,
  customClass: _react.PropTypes.string,
  fitToText: _react.PropTypes.bool,
  labelledById: _react.PropTypes.string.isRequired,
  describedById: _react.PropTypes.string,
  openOnFocus: _react.PropTypes.bool,
  highlightOnHover: _react.PropTypes.bool,
  buttonTestId: _react.PropTypes.string,
  inputTestId: _react.PropTypes.string,
  intl: _reactIntl.intlShape
};

InlineTextArea.defaultProps = {
  openOnFocus: true,
  highlightOnHover: false
};

exports.default = (0, _reactIntl.injectIntl)(InlineTextArea);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-text-area/lib/components/InlineTextArea.component.js
// module id = 1189
// module chunks = 0